import { RoleControlledActionConfiguration } from '@/types';

export const roleConfig: RoleControlledActionConfiguration = {
  createPaymentStacks: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
  updatePaymentStacks: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
  deletePaymentStacks: {
    owner: { restricted: false, hidden: false },
    admin: { restricted: false, hidden: false },
    customer_care: { restricted: false, hidden: false },
    sales_manager: { restricted: false, hidden: false },
    sales_representative: { restricted: true, hidden: false },
    support_specialist: { restricted: true, hidden: false },
    view_only: { restricted: true, hidden: false },
  },
};
